import { render, staticRenderFns } from "./IdCardLeave.vue?vue&type=template&id=39f859e8&scoped=true"
import script from "./IdCardLeave.vue?vue&type=script&lang=js"
export * from "./IdCardLeave.vue?vue&type=script&lang=js"
import style0 from "./IdCardLeave.vue?vue&type=style&index=0&id=39f859e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f859e8",
  null
  
)

export default component.exports